// Always give the page translator an English source, including after an
// unrelated React render. Locale-dependent source strings poison Google's
// restore cache and make memoized views disagree after a language switch.
const SOURCE_LOCALE = "en-US";
import { formatCompanyDate, formatCompanyDateTime } from "./companyTime";

export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return "-";
  return formatCompanyDate(value);
}

export function formatDateTime(dateStr: string): string {
  if (!dateStr) return "-";
  return formatCompanyDateTime(dateStr);
}

export function formatMonthYear(dateStr: string): string {
  if (!dateStr) return "-";
  return formatCompanyDate(dateStr.slice(0, 10), {
    year: "numeric",
    month: "short",
  });
}

export function formatCurrency(
  value: number | null | undefined,
  currency?: string | null,
): string {
  if (value == null || isNaN(value)) return "-";
  const formatted = value.toLocaleString(SOURCE_LOCALE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return currency ? `${currency} ${formatted}` : formatted;
}

export function formatEmissionValue(
  value: number | string | null | undefined,
): string {
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (num == null || isNaN(num)) return "0.00";
  return num.toFixed(2);
}

export function formatGroupedEmissionValue(
  value: number | string | null | undefined,
): string {
  if (value == null || value === "") return "—";
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  return number.toLocaleString(SOURCE_LOCALE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatReduction(value: number | null | undefined): string {
  if (value == null || isNaN(value)) return "0.0";
  return `${(value * 100).toFixed(1)}%`;
}

export function truncate(str: string, maxLen: number): string {
  if (str.length <= maxLen) return str;
  return str.slice(0, maxLen - 1) + "\u2026";
}
